export default {"src":"/_next/static/media/united-states-of-america.54c544d9.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};